/** Estados de vitrina Conoce Colombia */
export const PIPELINE_STATUS = {
  proximamente: { label: 'Próximamente', color: '#607d8b' },
  en_validacion: { label: 'En validación', color: '#ef6c00' },
  proximo_lanzamiento: { label: 'Próximo lanzamiento', color: '#5c6bc0' }
};

export const COMMISSION_YEAR1_PCT = 5;
export const COMMISSION_GP_PHASE4_NOTE =
  'Fase 4 GP — revisión año 2 hacia 10–15% según volumen y contrato';

export const JAVILAND_SALES_EMAIL = 'ventas@javiland.com';

/** Alejandra Puentes Sayo */
export const ALEJA_PROVIDER = {
  id: 'aleja',
  name: 'Alejandra Puentes Sayo',
  shortName: 'Aleja',
  specialty: 'Buceo · mar · Seaflower',
  instagram: 'https://www.instagram.com/aleja.sayo/',
  instagramHandle: '@aleja.sayo',
  whatsapp: '573218277761',
  whatsappDisplay: '321 8277761',
  commissionYear1Pct: COMMISSION_YEAR1_PCT,
  docProvidencia: 'PROPUESTA_EXPEDICION_PROVIDENCIA_ALEJA_AGO2026.md',
  docGorgona: 'PROPUESTA_DESTINO_GORGOVA_ALEJA_SEP2026.md'
};

/** Omar Londoño — Tapires Andinos */
export const TAPIRES_PROVIDER = {
  id: 'tapires',
  name: 'Tapires Andinos',
  operatorName: 'Omar Londoño',
  brand: 'Pinchake',
  specialty: 'Ecopedagogía · media y alta montaña',
  region: 'Ibagué, Tolima · Andes colombianos',
  rnt: '124193',
  instagram: 'https://www.instagram.com/pinchake/',
  instagramHandle: '@pinchake',
  operatorBadge: 'Operado por Tapires Andinos · RNT 124193',
  commissionYear1Pct: COMMISSION_YEAR1_PCT,
  doc: 'SUBPROYECTO_OMAR_JAVILAND.md'
};

/** Expediciones Aleja — disponibles */
export const ALEJA_EXPERIENCES = [
  {
    id: 'aleja-providencia-ago2026',
    providerId: 'aleja',
    title: 'Expedición Providencia',
    subtitle: 'Buceo · Reserva Seaflower',
    dates: '13–17 agosto 2026',
    duration: '5 días / 4 noches',
    location: 'Providencia, San Andrés y Providencia',
    operatorNetCop: 3400000,
    priceCop: 3570000,
    depositPct: 30,
    depositCop: 1071000,
    image: '/images/viajes-san-andres-providencia.png',
    pdf: 'PROPUESTA_EXPEDICION_PROVIDENCIA_ALEJA_AGO2026.pdf',
    highlights: ['6 buceos diurnos', 'Seaflower', 'Old Town', 'Guías certificados'],
    includes: [
      'Hospedaje, desayunos y almuerzos',
      '6 buceos diurnos, seguro y equipo',
      'Fotos subacuáticas y kit regalo'
    ],
    excludes: ['Tiquetes aéreos', 'Tarjeta turismo isla', 'Cenas'],
    operatorLine: 'Operado por Alejandra Puentes Sayo'
  },
  {
    id: 'aleja-gorgona-sep2026',
    providerId: 'aleja',
    title: 'Destino Gorgona',
    subtitle: 'Buceo avanzado · barco Vivax',
    dates: '21–25 septiembre 2026',
    duration: '5 días / 4 noches',
    location: 'Isla Gorgona, Pacífico colombiano',
    operatorNetCop: 5990000,
    priceCop: 6290000,
    depositPct: 30,
    depositCop: 1887000,
    slots: 12,
    certifiedDiversOnly: true,
    image: '/images/viajes-pacifico-ballenas.png',
    pdf: 'PROPUESTA_DESTINO_GORGOVA_ALEJA_SEP2026.pdf',
    highlights: ['12 cupos', '11 inmersiones', 'Nitrox', 'Solo buzos certificados'],
    includes: [
      'Cabina privada y alimentación',
      '9 inmersiones diurnas + 2 nocturnas',
      'Transporte Cali–Buenaventura–Cali, seguro, curso DAN'
    ],
    optional: 'Certificación PADI Nitrox online: $580.000 COP',
    operatorLine: 'Operado por Alejandra Puentes Sayo'
  }
];

/** Viaje personalizado — Javiland / viajes propios */
export const PERSONALIZED_TRIP = {
  id: 'personalizado',
  title: 'Viaje personalizado',
  subtitle: 'Viajes propios Javiland',
  location: 'Colombia',
  description:
    '¿Quieres un acompañamiento más personalizado? Te ayudamos a cuadrar tu viaje por Colombia según tus fechas, preferencias y presupuesto. Ideal para viajeros internacionales.',
  image: '/images/hero-viajes-colombia.png',
  highlights: ['A tu medida', 'Fechas flexibles', 'Cotización personalizada'],
  isPersonalized: true
};

/** Indi Stones — joyería Omar (piloto tienda) */
export const INDI_STONES_PROVIDER = {
  id: 'indi-stones',
  name: 'Indi Stones',
  operatorName: 'Omar Londoño',
  specialty: 'Joyería artesanal · cristales naturales',
  instagram: 'https://www.instagram.com/indi.stones/',
  instagramHandle: '@indi.stones',
  shopUrl: 'https://indistones.co/',
  commissionYear1Pct: COMMISSION_YEAR1_PCT
};

/** Próximos lanzamientos tienda Javiland (Indi Stones + catálogo ecosistema) */
export const TIENDA_PIPELINE = [
  {
    id: 'indi-collar-labradorita',
    providerId: 'indi-stones',
    title: 'Collar árbol de la Vida — Labradorita',
    subtitle: 'Indi Stones · plata',
    location: 'Joyería artesanal Colombia',
    priceFromCop: 115000,
    image: '/images/placeholders/placeholder-product.png',
    highlights: ['Hecho a mano', 'Labradorita', 'Plata'],
    pipelineStatus: 'proximo_lanzamiento',
    operatorLine: 'Indi Stones · aliado Javiland'
  },
  {
    id: 'indi-collar-crisocola',
    providerId: 'indi-stones',
    title: 'Collar árbol de la vida — Crisocola',
    subtitle: 'Indi Stones · plata',
    location: 'Joyería artesanal Colombia',
    priceFromCop: 110000,
    image: '/images/placeholders/placeholder-product.png',
    highlights: ['Crisocola', 'Diseño árbol de la vida'],
    pipelineStatus: 'proximo_lanzamiento',
    operatorLine: 'Indi Stones · aliado Javiland'
  },
  {
    id: 'indi-collar-rodocrosita',
    providerId: 'indi-stones',
    title: 'Collar Rodocrosita en Cobre',
    subtitle: 'Indi Stones',
    location: 'Joyería artesanal Colombia',
    priceFromCop: 69000,
    image: '/images/placeholders/placeholder-product.png',
    highlights: ['Rodocrosita', 'Cobre artesanal'],
    pipelineStatus: 'proximo_lanzamiento',
    operatorLine: 'Próximo en tienda Javiland'
  }
];

/** @deprecated Usar TIENDA_PIPELINE */
export const INDI_STONES_PIPELINE = TIENDA_PIPELINE;

/**
 * Tapires — no publicar en «Disponibles» sin fechas confirmadas.
 * Registro interno: ver OMAR_TAPIRES_CALENDARIO_VIAJES_2026.md
 */
export const TAPIRES_EXPERIENCES = [];

/** Pipeline viajes Tapires — visible solo con fecha + precio Javiland */
export const TAPIRES_PIPELINE = [
  {
    id: 'tapires-andes-expedicion',
    providerId: 'tapires',
    title: 'Expedición media y alta montaña',
    subtitle: 'Tolima · Andes colombianos',
    duration: 'Varios días (según ruta)',
    location: 'Ibagué, Tolima y ecosistemas andinos',
    image: '/images/montana.png',
    highlights: ['Ecopedagogía', 'Alta montaña', 'Experiencia Javiland'],
    pipelineStatus: 'proximamente',
    operatorLine: 'Conoce Colombia · Javiland',
    syncNote: 'Requiere fechas 2026 confirmadas con operador aliado'
  }
];

/** Pipeline — proyectos originales Javiland (no borrar) */
export const PIPELINE_DESTINATIONS = [
  {
    id: 'pacifico',
    title: 'Avistamiento de ballenas en el Pacífico',
    location: 'La Barra (Juanchaco) y Ladrilleros · Buenaventura',
    description:
      'Ecoturismo comunitario en el Pacífico colombiano. Temporada ballenas jorobadas, gastronomía y actividades con comunidad local.',
    image: '/images/viajes-pacifico-ballenas.png',
    highlights: ['Ballenas jorobadas', 'Comunidad local', 'Gastronomía'],
    pipelineStatus: 'proximamente'
  },
  {
    id: 'amazonas',
    title: 'Amazonas colombiano',
    location: 'Leticia y río Amazonas',
    description:
      'Inmersión en la selva amazónica: biodiversidad, río Amazonas y experiencias con comunidades indígenas.',
    image: '/images/viajes-amazonas.png',
    highlights: ['Selva amazónica', 'Biodiversidad', 'Comunidad indígena'],
    pipelineStatus: 'proximamente'
  },
  {
    id: 'tayrona',
    title: 'Santa Marta y playas del Tayrona',
    location: 'Santa Marta · Parque Tayrona',
    description:
      'Costa caribeña: Sierra Nevada, Parque Nacional Tayrona y playas con enfoque comunitario.',
    image: '/images/viajes-santa-marta-tayrona.png',
    highlights: ['Parque Tayrona', 'Sierra Nevada', 'Costa caribeña'],
    pipelineStatus: 'proximamente'
  },
];

export function formatCop(amount) {
  if (amount == null || Number.isNaN(Number(amount))) return null;
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    maximumFractionDigits: 0
  }).format(amount);
}

export function buildAlejaWhatsAppMessage(experience) {
  const lines = [
    `Hola Aleja, me interesa la expedición *${experience.title}* (${experience.dates}).`,
    '',
    'Vengo desde Javiland (javiland.com/conoce-colombia) — referido del ecosistema.',
    '',
    '¿Me confirmas cupos y los próximos pasos para la aventura?'
  ];
  return lines.join('\n');
}

export function buildAlejaWhatsAppUrl(experience) {
  const text = encodeURIComponent(buildAlejaWhatsAppMessage(experience));
  return `https://wa.me/${ALEJA_PROVIDER.whatsapp}?text=${text}`;
}

export function buildPersonalizedMailto({ name, email, phone, country, comments }) {
  const subject = encodeURIComponent('Conoce Colombia — Viaje personalizado (Javiland)');
  const body = encodeURIComponent(
    [
      'Solicitud de viaje personalizado — Conoce Colombia',
      '',
      `Nombre: ${name || ''}`,
      `Email: ${email || ''}`,
      `Teléfono: ${phone || ''}`,
      `País: ${country || ''}`,
      '',
      'Preferencias:',
      comments || ''
    ].join('\n')
  );
  return `mailto:${JAVILAND_SALES_EMAIL}?subject=${subject}&body=${body}`;
}

export function pipelineStatusLabel(statusId) {
  return PIPELINE_STATUS[statusId]?.label || statusId;
}

export function pipelineStatusColor(statusId) {
  return PIPELINE_STATUS[statusId]?.color || '#666';
}
